import { Badge as MantineBadge, BadgeProps } from '@mantine/core';

export type IBadgeProps = BadgeProps;

/** @registry Design-layer pass-through over Mantine Badge; import this instead of @mantine/core Badge outside src/design. */
export const Badge = MantineBadge;
